module.exports = __webpack_public_path__ + "static/img/solutionAdvantageIcon03.29a8d2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionAdvantageIcon03.png
// module id = +Py4
// module chunks = 0